import React from 'react';
import { RANK_LEVELS, getCurrentRank, getOverallProgress, getThresholdScore } from './progressLevels.ts';

interface SubtextProgressTrackerProps {
  score: number;
  realisticMaxScore: number;
  onOpenRankingsModal?: () => void;
}

export default function SubtextProgressTracker({ score, realisticMaxScore, onOpenRankingsModal }: SubtextProgressTrackerProps) {
  const currentRank = getCurrentRank(score, realisticMaxScore);
  const overallProgress = getOverallProgress(score, realisticMaxScore);

  return (
    <div className="subtext-progress-tracker" onClick={onOpenRankingsModal} style={{ cursor: onOpenRankingsModal ? 'pointer' : 'default' }}>
      <div className="progress-row">
        <div className="current-level-label">{currentRank.name}</div>
        <div 
          className="progress-line"
          style={{ '--progress-width': `${overallProgress}%` } as React.CSSProperties}
        >
          {RANK_LEVELS.map((rank, index) => {
            const thresholdScore = getThresholdScore(rank, realisticMaxScore);
            const isActive = score >= thresholdScore;
            const isCurrent = rank.id === currentRank.id;
            
            return (
              <div 
                key={rank.name} 
                className={`progress-node ${isActive ? 'active' : ''} ${isCurrent ? 'current' : ''}`}
                style={{ 
                  left: `${(index / (RANK_LEVELS.length - 1)) * 100}%` 
                }}
                title={`${rank.name}: ${thresholdScore}+ points (${score} points)`}
              >
                {isCurrent && (
                  <span className="score-display">{score}</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
} 